import React from 'react';
import ReportSectionPage from '../../../common/components/reports/ReportSectionPage';

const OrganizationsReport = () => {
  return <ReportSectionPage scope="super-admin" section="organizations" title="Org License Report" />;
};

export default OrganizationsReport;
